//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox,
    faPencil,
    faPenToSquare,
    faTrash,
    
} from "@fortawesome/free-solid-svg-icons";

const RenderRow = ({ index, style, productos = [], filter, setProductToEdit }) => {

    const disabled = true;

        return (
            <div style={style} className='container-p-list productRow'>
                <li>
                    <div className='container-p-list-item'>
                        <div className="container-p-list-item-horizontal">
                            <div className='list-item-icon-p'><FontAwesomeIcon icon={faBox} /></div>
                            <div className="label-title-products">Tipo Produto: <div className="label-products">{productos[index].tipPro}</div></div>
                            <div className="label-title-products">Código Articulo: <div className="label-products">{productos[index].artCod}</div> </div>
                            <div className="label-title-products">Codigo Reducido: <div className="label-products">{productos[index].codRed}</div> </div>
                            <div className="label-title-products">Descripción: <div className="label-products">{productos[index].descrp}</div></div>
                            <div className="label-title-products">Precio: <div className={`${(disabled) ? 'disabledText' : ''} label-products`}>${(disabled) ? 'XXXXXX' : productos[index].precio}</div></div>
                        </div>
                        <div className="utilitesDiv" onClick={()=>setProductToEdit(productos[index])}>
                            <FontAwesomeIcon className="utilityIcon" icon={faPencil}/>
                        </div>
                    </div>
                </li>
            </div>);
};

export default RenderRow